import { render, staticRenderFns } from "./PurchaseOrderLayout.vue?vue&type=template&id=cd839124&scoped=true&"
import script from "./PurchaseOrderLayout.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderLayout.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrderLayout.vue?vue&type=style&index=0&id=cd839124&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd839124",
  null
  
)

component.options.__file = "PurchaseOrderLayout.vue"
export default component.exports